import styled from '@emotion/styled';

export const LoginContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, rgba(165, 80, 255, 1) 0%, rgba(118, 72, 200, 1) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  
  /* 🔧 수정: 스크롤 지원 추가 */
  overflow-y: auto;
  
  /* 세로로 긴 화면에서도 중앙 정렬 유지 */
  @media (max-height: 700px) {
    align-items: flex-start;
    padding-top: 40px;
    padding-bottom: 40px;
  }
`;

export const LoginCard = styled.div`
 width: 100%;
 max-width: 480px;
 background: #ffffff;
 border-radius: 16px;
 box-shadow: 0px 20px 60px rgba(0, 0, 0, 0.1);
 padding: 48px 40px;
 box-sizing: border-box;
 
 /* 🔧 수정: 유연한 높이 설정 */
 margin: auto;
 max-height: calc(100vh - 40px);
 overflow-y: auto;
 
 /* 작은 화면에서의 반응형 처리 */
 @media (max-width: 768px) {
   max-width: 100%;
   padding: 32px 24px;
   border-radius: 12px;
   margin: 20px 0;
   max-height: calc(100vh - 40px);
 }
 
 /* 🔧 추가: 매우 작은 화면 높이에서의 처리 */
 @media (max-height: 600px) {
   padding: 24px 32px;
   margin: 10px 0;
   max-height: calc(100vh - 20px);
 }
 
 @media (max-width: 480px) and (max-height: 600px) {
   padding: 20px 20px;
   margin: 10px 0;
   max-height: calc(100vh - 20px);
 }
`;

export const LoginHeader = styled.div`
  text-align: center;
  margin-bottom: 40px;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 600px) {
    margin-bottom: 24px;
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 32px;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 600px) {
    margin-bottom: 20px;
  }
`;

export const LogoIcon = styled.div`
  font-size: 32px;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 28px;
  }
`;

export const LogoText = styled.h1`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  line-height: 29px;
  font-weight: 700;
  margin: 0;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const LoginTitle = styled.h2`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 28px;
  line-height: 36px;
  font-weight: 600;
  margin: 0 0 8px 0;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 24px;
    line-height: 30px;
    margin: 0 0 6px 0;
  }
`;

export const LoginSubtitle = styled.p`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin: 0;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const ServerStatus = styled.div`
  margin: 16px 0 0 0;
  padding: 12px 16px;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  text-align: center;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 600px) {
    margin: 12px 0 0 0;
    padding: 10px 14px;
    font-size: 13px;
    line-height: 18px;
  }
  
  ${({ status }) => {
    if (status === 'checking') {
      return `
        background: rgba(106, 66, 242, 0.1);
        border: 1px solid rgba(106, 66, 242, 0.2);
        color: #6A42F2;
      `;
    } else if (status === 'offline') {
      return `
        background: rgba(255, 75, 75, 0.1);
        border: 1px solid rgba(255, 75, 75, 0.2);
        color: #FF4B4B;
      `;
    } else if (status === 'online') {
      return `
        background: rgba(0, 148, 68, 0.1);
        border: 1px solid rgba(0, 148, 68, 0.2);
        color: #009444;
      `;
    }
  }}
`;

export const RetryButton = styled.button`
  margin-left: 12px;
  padding: 4px 12px;
  background: #FF4B4B;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.9;
  }
`;

export const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 600px) {
    gap: 20px;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 600px) {
    gap: 6px;
  }
`;

export const FormLabel = styled.label`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 13px;
    line-height: 18px;
  }
`;

export const FormInput = styled.input`
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background: #ffffff;
  border: 2px solid ${({ hasError }) => hasError ? '#FF4B4B' : '#e5e7eb'};
  padding: 12px 16px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #333333;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
  
  /* 🔧 추가: 작은 화면에서 높이 조정 */
  @media (max-height: 600px) {
    height: 44px;
    padding: 10px 14px;
    font-size: 15px;
    line-height: 22px;
  }
  
  &:focus {
    outline: none;
    border-color: ${({ hasError }) => hasError ? '#FF4B4B' : '#6A42F2'};
  }
  
  &::placeholder {
    color: #9ca3af;
  }
  
  &:disabled {
    background: #f9fafb;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const PasswordInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const PasswordToggle = styled.button`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 20px;
  color: #666666;
  transition: color 0.2s ease;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    right: 14px;
    font-size: 18px;
  }
  
  &:hover:not(:disabled) {
    color: #333333;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.div`
  color: #FF4B4B;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  background: rgba(255, 75, 75, 0.1);
  border: 1px solid rgba(255, 75, 75, 0.2);
  border-radius: 6px;
  padding: 12px 16px;
  margin: -8px 0 0 0;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 13px;
    line-height: 18px;
    padding: 10px 14px;
  }
`;

export const FormOptions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 600px) {
    gap: 12px;
  }
  
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  border-radius: 4px;
  background: #ffffff;
  border: 2px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.2s ease;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    width: 16px;
    height: 16px;
  }
  
  &:checked {
    background: #6A42F2;
    border-color: #6A42F2;
  }
  
  &:focus {
    outline: 2px solid rgba(106, 66, 242, 0.3);
    outline-offset: 2px;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CheckboxLabel = styled.label`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  cursor: pointer;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 13px;
    line-height: 18px;
  }
`;

export const ForgotPassword = styled.a`
  color: #6A42F2;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  text-decoration: none;
  transition: opacity 0.2s ease;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 13px;
    line-height: 18px;
  }
  
  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background: #6A42F2;
  border: none;
  cursor: pointer;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  transition: opacity 0.2s ease;
  
  /* 🔧 추가: 작은 화면에서 높이 조정 */
  @media (max-height: 600px) {
    height: 44px;
    font-size: 15px;
    line-height: 22px;
  }
  
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
  
  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 32px 0;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 600px) {
    margin: 24px 0;
    gap: 12px;
  }
`;

export const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  background: #e5e7eb;
`;

export const DividerText = styled.span`
  color: #9ca3af;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 13px;
    line-height: 18px;
  }
`;

export const DemoSection = styled.div`
  text-align: center;
  margin-bottom: 32px;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 600px) {
    margin-bottom: 24px;
  }
`;

export const DemoTitle = styled.h3`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  margin: 0 0 16px 0;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 600px) {
    font-size: 13px;
    line-height: 18px;
    margin: 0 0 12px 0;
  }
`;

export const DemoButtons = styled.div`
  display: flex;
  gap: 12px;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 600px) {
    gap: 10px;
  }
  
  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

export const DemoButton = styled.button`
  flex: 1;
  height: 40px;
  border-radius: 6px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  transition: all 0.2s ease;
  
  /* 🔧 추가: 작은 화면에서 높이 조정 */
  @media (max-height: 600px) {
    height: 36px;
    font-size: 13px;
    line-height: 18px;
  }
  
  &:hover:not(:disabled) {
    background: #f3f4f6;
    border-color: #d1d5db;
    color: #333333;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SignupLink = styled.p`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  text-align: center;
  margin-top: 20px;
  
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 13px;
    line-height: 18px;
  }
  
  a {
    color: #6A42F2;
    font-weight: 600;
    text-decoration: none;
    transition: opacity 0.2s ease;
    
    &:hover {
      opacity: 0.8;
      text-decoration: underline;
    }
  }
`;

export const LogoOption = styled.div`
  width: 100%;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  opacity: 1;
  transition: opacity 0.2s ease;
`;

export const LogoImage = styled.img`
  width: 100px;
  height: 40px;
  object-fit: contain;
  ${({ isCollapsed }) => isCollapsed && `
    width: 24px;
    height: 24px;
  `}
`;
